import {
  GraduationCap,
  Globe,
  Clock3,
  BookOpen,
  Wallet,
  CalendarDays,
  DockIcon,
} from "lucide-react";

import { motion } from "framer-motion";

export default function InfoCards({
  titulo,
  modalidad,
  duracion,
  campo,
  inversion,
  inicio,
  resolucion
}) {
  const cards = [
    { icon: GraduationCap, title: "Título", value: titulo },
    { icon: Globe, title: "Modalidad", value: modalidad },
    { icon: Clock3, title: "Duración", value: duracion },
    { icon: BookOpen, title: "Campo amplio", value: campo },
    { icon: Wallet, title: "Inversión", value: inversion },
    { icon: CalendarDays, title: "Inicio", value: inicio },
    { icon: DockIcon, title: "Resolución", value: resolucion },
  ];

  // Filtramos primero para saber cuántas tarjetas reales tenemos
  const visibleCards = cards.filter((card) => card.value);

  return (
    <section className="py-4 md:py-8 bg-slate-50 px-4">
      <div className="max-w-6xl mx-auto">
        {/* grid-cols-2 en móvil para compactar el espacio y no hacer scroll infinito */}
        <div className="grid grid-cols-2 md:grid-cols-2 xl:grid-cols-3 gap-3 md:gap-4">
          {visibleCards.map((card, index) => {
            const Icon = card.icon;
            
            // Si hay un número impar de tarjetas, hacemos que la última ocupe todo el ancho en móvil
            const isLastOdd = index === visibleCards.length - 1 && visibleCards.length % 2 !== 0;

            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: index * 0.05 }}
                className={`flex flex-col sm:flex-row items-start gap-2 sm:gap-4 rounded-xl md:rounded-2xl border border-slate-200 bg-white p-3 shadow-sm ${
                  isLastOdd ? "col-span-2 sm:col-span-1" : ""
                }`}
              >
                {/* Icono ligeramente más pequeño en móvil para ahorrar espacio */}
                <div className="flex h-9 w-9 sm:h-10 sm:w-10 flex-shrink-0 items-center justify-center rounded-full bg-[#004270]/10">
                  <Icon
                    size={18}
                    className="text-[#004270] sm:scale-110"
                    strokeWidth={2.3}
                  />
                </div>

                <div className="min-w-0 flex-1 w-full">
                  <p className="text-[9px] sm:text-[10px] font-bold uppercase tracking-wider text-slate-500 truncate">
                    {card.title}
                  </p>

                  {/* Bajamos a text-sm en móvil para que textos largos (como Título o Campo amplio) no rompan el diseño */}
                  <div className="mt-0.5 text-sm sm:text-base font-medium text-[#004270] break-words line-clamp-3">
                    {card.value}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}